// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ny-0";